import { render } from "./CommercialBookingType.vue?vue&type=template&id=036cd0e9"
import script from "./CommercialBookingType.vue?vue&type=script&lang=js"
export * from "./CommercialBookingType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-clean-homes-booking/abdom-clean-homes-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__